<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div id="user-edit-tab-info">
    <!-- Avatar Row -->

    <!-- Content Row -->
    <div class="tab-top-part">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full">
          <!-- <h3>Session Type - {{session_data.SessionTypeDetails.TypeName}}</h3> -->
          <div class="custom-head-wrap">
            <!-- <h2 class="cms-custom-heading">Session Type - {{sessionType.label}}</h2>
                <p class="mt-1 mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p> -->
            <span class="edit-name-icon" style="display: none"
              ><feather-icon icon="EditIcon"
            /></span>
            <input
              type="text"
              v-click-outside="hideFullName"
              @click="toggleFullName"
              name="FirstName"
              v-show="showHideFullName"
              id="FirstName"
              placeholder="First Name*"
              v-model="data_local.FirstName"
              v-validate="'required'"
            />

            <input
              type="text"
              v-click-outside="hideFullName"
              @click="toggleFullName"
              name="LastName"
              v-show="showHideFullName"
              id="LastName"
              placeholder="Last Name"            
              v-model="data_local.LastName"
            />

            <input
              type="text"
              v-show="!showHideFullName"
              @click="toggleFullName"
              name="FullName"
              class="w-full full-name-box"
              id="FullName"
              placeholder="Attendee Name*"
              v-model="data_local.Name"
              readonly
            />
          </div>
          <span class="text-danger text-sm" v-show="errors.has('LastName')"
            >The Name field is required</span
          >
          <span class="text-danger text-sm" v-show="errors.has('FirstName')"
            >The Name field is required</span
          >
        </div>
        <div class="vx-col md:w-5/12 w-full mt-4">
          <div class="image-wrap-area border-1">
            <div class="flex items-center flex-col sm:flex-row">
              <img :src="imgSrc" class="mr-6 rounded h-24 w-24" />
              <!-- <vs-avatar :src="data_local.ProfilePictureURL" size="80px" class="mr-4" /> -->
              <div>
                <input
                  id="uploadAvatar"
                  type="file"
                  class="hidden"
                  ref="update_avatar_input"
                  @change="update_avatar"
                  accept="image/*"
                />

                <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                <vs-button class="" @click="$refs.update_avatar_input.click()"
                  >Upload</vs-button
                >
                <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

                <!--<vs-button type="border" color="danger">Remove Avatar</vs-button>-->
              </div>
            </div>
            <p class="mb-0 mt-2">High quality image: 200x200px (1:1 ratio)</p>
          </div>
        </div>
        <!-- <div class="vx-col md:w-1/3 w-full mt-4">
          <label>
            First Name
            <span class="rqrd">*</span>
          </label>
          <vs-input
            class="w-full mt-4"
            v-model="data_local.FirstName"
            v-validate="'required'"
            name="First Name"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('First Name')"
          >{{ errors.first('First Name') }}</span>
        </div>

        <div class="vx-col md:w-1/3 w-full mt-4">
          <label>
            Last Name
            <span class="rqrd">*</span>
          </label>
          <vs-input
            class="w-full mt-4"
            v-model="data_local.LastName"
            v-validate="'required'"
            name="Last Name"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Last Name')"
          >{{ errors.first('Last Name') }}</span>
        </div> -->

        <div class="vx-col md:w-4/12 w-full mt-4">
          <label>
            Email
            <span class="rqrd">*</span>
          </label>
          <vs-input
            autocomplete="off"
            class="w-full mt-4"
            v-model="data_local.Email"
            type="email"
            v-validate="'required|email'"
            name="Email"
            :readonly="emailFieldReadOnly"
          />
          <span class="text-danger text-sm" v-show="errors.has('Email')">{{
            errors.first("Email")
          }}</span>
        </div>

        <div
          class="vx-col md:w-3/12 w-full mt-4"
          v-if="data_local.Password || AttendeeId"
        >
          <label>
            Password
            <!-- <span class="rqrd">*</span> -->
          </label>
          <div class="password-wrap">
            <vs-input
              autocomplete="off"
              class="w-full mt-4"
              value="******"
              disabled
              type="password"
              name="Password"
            />
            <a class="rst-pwd" v-on:click="openResetPasswordModal(AttendeeId)"
              >Reset Password</a
            >
          </div>
          <!-- <vs-input
            autocomplete="off"
            class="w-full mt-4"
            v-model="data_local.Password"
            type="text"
            v-validate="'required|min:4'"
            name="Password"
          /> -->
          <!-- <span
            class="text-danger text-sm"
            v-show="errors.has('Password')"
          >{{ errors.first('Password') }}</span> -->
          <!-- <a href="javascript:void(0)" @click="getLoginUrl">Login Url</a> -->
        </div>

        <div class="vx-col md:w-3/12 w-full mt-4">
          <label>Phone</label> 
          <VuePhoneNumberInput :default-country-code="data_local.PhoneCountryCode" v-model="data_local.Phone" name="Phone" class="w-full mt-7" :preferredCountries="['US', 'GB', 'SG', 'IN']" @update="setPhoneCode" />
          <!-- <vs-input class="w-full mt-4" v-model="data_local.Phone" name="Phone" /> -->
          <span class="text-danger text-sm" v-show="errors.has('Phone')">{{
            errors.first("Phone")
          }}</span>
        </div>

        <div class="vx-col md:w-1/3 w-full mt-4">
          <label>Registration Type</label>
          <div class="track-wrapper">
            <v-select
              class="mt-4 track-select"
              label="RegistrationType"
              :options="RegistrationTypes"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="data_local.RegistrationType"
            />
            <vs-button
              class="mt-4 reg-type-button"
              color="primary"
              type="filled"
              @click="fetch_ticket_data(null)"
              >Add</vs-button
            >
          </div>
        </div>

        <div class="vx-col md:w-5/12 w-full mt-4">
          <label>Organization</label>
          <vs-input
            class="w-full mt-4"
            v-model="data_local.Company"
            name="Company"
          />
        </div>

        <div class="vx-col md:w-1/3 w-full mt-4">
          <label>Job Title</label>
          <vs-input
            class="w-full mt-4"
            v-model="data_local.Designation"
            name="Designation"
          />
        </div>

        <div class="vx-col md:w-1/3 w-full mt-4">
          <label>Website</label>
          <vs-input
            class="w-full mt-4 icon-center"
            v-model="data_local.Website"
            icon-pack="feather"
            icon="icon-codepen"
            icon-no-border
            v-validate="'url:require_protocol'"
            name="Website"
          />
          <span class="text-danger text-sm" v-show="errors.has('Website')">{{
            errors.first("Website")
          }}</span>
        </div>

        <div class="vx-col md:w-1/3 w-full mt-4">
          <label>Country</label>
          <v-select
            class="mt-4"
            :options="countries"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="data_local.Country"
            name="Country"
          />
        </div>

        <div class="vx-col sm:w-2/2 w-full mt-4">
          <label>Enter Search Keywords</label>
          <!-- <vs-input class="w-full mt-4" placeholder="Add multiple keywords separated by comma. eg: marketing, branding, technology" v-model="data_local.Tags" name="Tags" /> -->
          <input-tag
            class="w-full mt-4"
            placeholder="Add multiple keywords separated by comma. eg: marketing, branding, technology"
            v-model="data_local.Tags"
            name="Tags"
          ></input-tag>
          <!--<span class="text-danger text-sm" v-show="errors.has('Tags')">{{ errors.first('Tags') }}</span>-->
        </div>

        <!-- <div class="vx-col md:w-1/3 w-full mt-4">
          <label>Attendee Type</label>
          <v-select
            class="mt-4"
            :options="['FREE', 'PAID']"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="data_local.FormType"
          />
        </div> -->

        <div class="vx-col md:w-1/1 w-full mt-4">
          <label>Short Bio</label>
          <div class="description-edior mt-4">
            <!-- <quill-editor v-model="data_local.Profile"></quill-editor> -->
            <ckeditor
              class="desc-event"
              v-model="data_local.Profile"
              :config="editorConfig"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="tab-botttom-sticky-part">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="mt-2" @click="$router.push('/event/attendees')"
              >Back To List</vs-button
            >
            <vs-button
              class="ml-auto mt-2"
              type="border"
              color="warning"
              @click="reset_data"
              >Reset</vs-button
            >
            <vs-button
              class="ml-4 mt-2"
              @click="before_save(true)"
              :disabled="!validateForm"
              color="success"
              >Save &amp; Continue</vs-button
            >
            <vs-button
              class="ml-4 mt-2"
              @click="before_save(false)"
              :disabled="!validateForm"
              color="success"
              >Save &amp; Exit</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <vs-popup class="holamundo" title="Login URL" :active.sync="popupActive">
      <div class="vx-row">
        <div class="vx-col md:w-9/12 mt-4">
          <vs-input class="w-full" id="LoginURL" v-model="LoginURL" />
        </div>
        <div class="vx-col md:w-2/12 mt-4">
          <vs-button
            color="dark"
            type="filled"
            @click.stop.prevent="copyLoginUrl"
            >Copy</vs-button
          >
        </div>
      </div>
    </vs-popup>
    <vs-popup class="holamundo customnewpopup" :title="`${ticket_data && ticket_data.RegistrationTypeId ? 'Edit' : 'Add'} Registration Type`" :active.sync="popupTicketPopup">
      <vx-card v-if="ticket_data">
        <ticket-edit-tab-info :data="ticket_data" v-on:reloadGrid="reloadGrid" />
      </vx-card>
    </vs-popup>
    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      v-if="cropImageUrl"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import CountryDB from "@/assets/CountryList.ts";
import InputTag from "vue-input-tag";
import Swal from "sweetalert2";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";

import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
import moduleTicketManagement from "@/store/ticket-management/moduleTicketManagement.js";
import TicketEditTabInfo from "@/views/ticket/TicketEditTabInfo.vue";
import ClickOutside from "vue-click-outside";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";

export default {
  components: {
    VuePhoneNumberInput,
    vSelect,
    quillEditor,
    InputTag,
    ckeditor: CKEditor.component,
    PhotowallResizeComponent,
    TicketEditTabInfo
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      imgSrc:
        this.data.ProfilePictureURL == "" ||
        this.data.ProfilePictureURL == undefined
          ? require("@/assets/images/default_avatar.jpg")
          : this.data.ProfilePictureURL,
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      AttendeeId: this.$route.params.AttendeeId
        ? this.$route.params.AttendeeId
        : null,
      countries: CountryDB.CountryList.map(function (item) {
        return item["name"].replace(/[^a-zA-Z ]/g, "");
      }),
      content: ` `,
      emailFieldReadOnly: false,
      popupActive: false,
      LoginURL: null,
      RegistrationTypes: [],
      editorConfig: CKconfig.editorConfig,
      popupTicketPopup: false,
      ticket_data: null,
      imageRatio: 1 / 1,
      cropImageUrl: null,
      resetCropper: 0,
      displayImageRatio: "1:1",
      popupCropper: false,
      showHideFullName: false,
    };
  },
  computed: {
    imgSrc: function () {
      if (this.data.ProfilePictureURL != null) {
        return data.ProfilePictureURL;
      } else {
        return "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Favatar.jpg?alt=media";
      }
    },
    status_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status,
        };
      },
      set(obj) {
        this.data_local.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role,
        };
      },
      set(obj) {
        this.data_local.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    setPhoneCode(data) {
      if(data && data.formattedNumber){
        this.data_local.Phone = data.nationalNumber;
        this.data_local.PhoneCountryCode = data.countryCode;
      }      
    },
    toggleFullName() {
      if (this.data_local.FirstName == "" && this.data_local.LastName == "") {
        this.data_local.Name = "";
      } else {
        this.data_local.Name =
          this.data_local.FirstName + " " + this.data_local.LastName;
      }

      this.showHideFullName = true;
    },
    hideFullName() {
      if (this.data_local.FirstName == "" && this.data_local.LastName == "") {
        this.data_local.Name = "";
      } else {
        this.data_local.Name =
          this.data_local.FirstName + " " + this.data_local.LastName;
      }

      this.showHideFullName = false;
    },
    croppedImagePath(blob) {
      this.imgSrc = blob;
      this.popupCropper = false;
    },
    reloadGrid(){
      this.popupTicketPopup = false;
      this.ticket_data = null;
      this.registrationTypes();
    },
    fetch_ticket_data(RegistrationTypeId) {
      this.ticket_data = null;
      this.$vs.loading();
      this.$store.dispatch("TicketManagement/fetchRegistrationType", RegistrationTypeId)
        .then(res => {
          this.$vs.loading.close();
          if(res.data.RegistrationTypeId){
            this.ticket_data = res.data;
            this.popupTicketPopup = true;
          }
          else if(RegistrationTypeId == null){
            this.ticket_data = res.data;
            this.popupTicketPopup = true;
          }
          else
          {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                //title: "Ticket",
                text: "Registartion Type not found in Registartion JSON!",
              });
          }
          
        })
    },    
    copyLoginUrl() {
      /* Get the text field */
      var copyText = document.getElementById("LoginURL");

      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand("copy");

      /* Alert the copied text */
      this.$vs.notify({
        position: "top-center",
        color: "success",
        //title: "Clip",
        text: "Login URL copied to clipboard",
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    before_save(form_continue = false) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes(form_continue);
        }
      });
    },
    save_changes(form_continue = false) {
      /* eslint-disable */
      if (!this.validateForm) return;

      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      this.$vs.loading();
      /* eslint-enable */
      this.data_local.ProfilePictureURL = this.imgSrc;
      const Id = this.$route.params.AttendeeId;
      if (Id) {
        this.$store
          .dispatch("attendeeManagement/updateAttendee", {
            id: Id,
            data: this.data_local,
          })
          .then((res) => {
            this.$vs.notify({
              position: "top-center",
              color: "success",
              title: "Attendee",
              text: "Attendee updated successfully.",
            });
            this.$vs.notify({
              time: 5000,
              position: "top-right",
              color: "dark",
              title: "Next Steps...",
              text: "Use the Mail Attendee option to send login credentials",
            });
            this.$vs.loading.close();
            if (form_continue) this.$emit("activateTab", 1);
            else this.$router.push("/event/attendees/");
          })
          .catch((err) => {
            this.$vs.loading.close();
            console.error(err);
          });
      } else {
        this.$store
          .dispatch("attendeeManagement/addAttendeeExt", { data: this.data_local })
          .then((res) => {
            console.log("res-----", res);
            if (res.status == 500) {
              this.$vs.notify({
                color: "danger",
                title: "Attendee",
                text: res.message,
              });
              this.$vs.loading.close();
            }
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                title: "Attendee",
                text: "Attendee created successfully.",
              });

              this.$vs.notify({
                time: 5000,
                position: "top-right",
                color: "dark",
                title: "Next Steps...",
                text: "Use the Mail Attendee option to send login credentials",
              });
              this.$vs.loading.close();
              if (form_continue) {
                this.$router.push({
                  name: "attendee-edit",
                  params: {
                    AttendeeId: res.Id,
                  },
                });
              } else this.$router.push("/event/attendees/");
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            //console.error(err)
          });
      }
    },
    reset_data() {
      document.getElementById("uploadAvatar").value = "";
      this.data_local = JSON.parse(JSON.stringify(this.data));
      this.imgSrc =
        this.data.ProfilePictureURL == "" ||
        this.data.ProfilePictureURL == undefined
          ? require("@/assets/images/default_avatar.jpg")
          : this.data.ProfilePictureURL;
    },
    update_avatar(input) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        this.data_local.file = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.resetCropper += 1;
          this.cropImageUrl = null;
          this.cropImageUrl = e.target.result;
          this.popupCropper = true;
          //this.imgSrc = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    getLoginUrl() {
      let vs = this.$vs;
      let vm = this;
      vs.loading();
      let email = this.data_local.Email;
      let password = this.data_local.Password;
      this.$store
        .dispatch("userManagement/getFirebaseAuth", {
          email: email,
          password: password,
        })
        .then(function (response) {
          vs.loading.close();
          vm.LoginURL = response;
          vm.popupActive = true;
        });
    },
    registrationTypes() {
      this.$vs.loading();
      this.$store
        .dispatch("TicketManagement/fetchRegistrationTypes")
        .then((res) => {
          this.RegistrationTypes = res.map(item=>{ 
            return {
              RegistrationTypeId: item.RegistrationTypeId,
              RegistrationType: item.RegistrationType,
              ColorCode: item.ColorCode,
            }
          });
          this.$vs.loading.close();
        });
    },
    openResetPasswordModal(userId) {
      const { value: text } = Swal.fire({
        title: "Enter the Password you want to set for the User",
        input: "password",
        inputPlaceholder: "Enter 6-16 digit Password and hit the Submit button",
        showCancelButton: true,
        confirmButtonText: "Submit",
        inputValidator: (value) => {
          this.$store
            .dispatch("attendeeManagement/resetPasswordForUser", {
              userId: userId,
              password: value,
            })
            .then((res) => {
              this.$vs.notify({
                position: "top-center",
                color: "success",
                title: "Attendee",
                text: "Attendee Password updated successfully.",
              });
            })
            .catch((err) => {
              console.error(err);
            });
        },
      }).then(function (result) {});
    },
  },
  mounted() {
    this.popupItem = this.$el;
    if (
      this.$route.params.AttendeeId != undefined ||
      this.$route.params.AttendeeId != null
    ) {
      this.emailFieldReadOnly = true;
    }
  },
  created() {
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule("userManagement", moduleUserManagement);
      moduleUserManagement.isRegistered = true;
    }
    if (!moduleTicketManagement.isRegistered) {
      this.$store.registerModule("TicketManagement", moduleTicketManagement);
      moduleTicketManagement.isRegistered = true;
    }
    this.registrationTypes();
  },
};
</script>
